import { MESSAGES } from '@guuru/chat-common';
import {
  appendLocalMessage,
  ChatAPI,
  replaceLastLocalMessage,
} from '@guuru/chat-web';
import { delay as sleep } from '@guuru/helpers-common';
import { i18n } from '@guuru/translation-web';

const requestVisitorRole = 'bot:::requestVisitorRole';

const addBotRequestVisitorRole = (question, roles, delay = true) =>
  sleep(delay ? ChatAPI.getBotEllipsisMessageDelay() : 0).then(() => {
    const message = ChatAPI.messages.createBotMessage(
      Date.now(),
      question,
      MESSAGES.visitorRole,
      { roles },
      true,
      false,
    );
    if (Object.keys(roles).length === 0 && roles.constructor === Object) {
      ChatAPI.pushPendingMessages(message);
    }
    return message;
  });

const addVisitorRole = (partnerId, option) => {
  const message = ChatAPI.messages.createAnonymousTextMessage(
    option.displayName,
    true,
    false,
  );
  ChatAPI.pushPendingMessages(message);
  ChatAPI.storeVisitorRole(partnerId, option.uid);
  return message;
};

const prepareMessage = (partnerName) => {
  const requestMessage = i18n.t(requestVisitorRole, { partnerName });
  const leadRoleOption = i18n.t('bot:::leadRole');
  const userRoleOption = i18n.t('bot:::userRole');
  const message = {
    displayName: requestMessage,
    options: [
      {
        uid: 'lead',
        displayName: leadRoleOption,
        question: requestMessage,
      },
      {
        uid: 'user',
        displayName: userRoleOption,
        question: requestMessage,
      },
    ],
  };
  return message;
};

export default {
  validate(partnerId) {
    return !ChatAPI.storeRetrieveVisitorRole(partnerId);
  },
  async render(partnerId) {
    const { name } = await ChatAPI.getChatSettings(partnerId);
    const message = prepareMessage(name);
    const requestVisitorRoleMessage = await addBotRequestVisitorRole(
      message.displayName,
      message.options,
    );
    appendLocalMessage(requestVisitorRoleMessage);
  },

  async processResponse(partnerId, option) {
    const message = await addBotRequestVisitorRole(option.question, {}, false);
    replaceLastLocalMessage(message);

    const responseMessage = addVisitorRole(partnerId, option);
    appendLocalMessage(responseMessage);
  },
};
